// extracted by mini-css-extract-plugin
export default {"cls1":"CgkjUebgEpJq5O2P2Oof","cls2":"Qpvo0hWGSww0GfdOXNk9 CgkjUebgEpJq5O2P2Oof"};